import React from 'react';
import { BarChart3, Download, Calendar } from 'lucide-react';

export default function ReportsPage() {
  const reports = [
    { id: 1, type: 'WEEKLY', title: 'Weekly Visibility Report', date: 'Jul 7, 2025', status: 'Ready' },
    { id: 2, type: 'WEEKLY', title: 'Weekly Visibility Report', date: 'Jun 30, 2025', status: 'Ready' },
    { id: 3, type: 'MONTHLY', title: 'Monthly Performance Summary', date: 'Jun 30, 2025', status: 'Ready' },
    { id: 4, type: 'WEEKLY', title: 'Weekly Visibility Report', date: 'Jun 23, 2025', status: 'Ready' },
  ];

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
        <div>
          <span className="text-xs font-medium tracking-widest uppercase block mb-2 text-stone-500">Analytics</span>
          <h1 className="font-serif text-2xl md:text-3xl text-stone-900 dark:text-white">Reports</h1>
        </div>
      </div>

      <div className="space-y-3">
        {reports.map(report => (
          <div key={report.id} className="bg-white dark:bg-stone-800 border border-stone-200 dark:border-stone-700 p-4 hover:border-stone-400 transition-colors">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded flex items-center justify-center bg-stone-100 dark:bg-stone-700">
                  <BarChart3 className="w-5 h-5 text-stone-600 dark:text-stone-300" />
                </div>
                <div>
                  <p className="font-medium text-stone-900 dark:text-white">{report.title}</p>
                  <div className="flex items-center gap-2 mt-1">
                    <Calendar className="w-3 h-3 text-stone-400" />
                    <span className="text-sm text-stone-500">{report.date}</span>
                    <span className="px-2 py-0.5 text-xs font-medium bg-stone-100 text-stone-600 dark:bg-stone-700 dark:text-stone-300">{report.type}</span>
                  </div>
                </div>
              </div>
              <button className="px-3 py-1.5 text-sm border border-stone-200 dark:border-stone-700 bg-white dark:bg-stone-800 text-stone-600 flex items-center gap-1 hover:bg-stone-50">
                <Download className="w-4 h-4" /> Download
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
